import type {
  MemberTransactionFilters,
  MemberTransactionsTableColumns
} from '@library/types/members/memberTransactions';
import type { TableColumn } from '@library/types/utils';

export const defaultTransactionFilters: MemberTransactionFilters = {
  transactionDate: undefined,
  transactionTypes: []
};

export const MEMBER_TRANSACTIONS_TABLE_HEADER: Array<
  TableColumn<MemberTransactionsTableColumns>
> = [
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'amount_cents',
    essential: true,
    label: 'Amount',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'type',
    essential: true,
    label: 'Type',
    sortEnabled: false,
    width: 'w-1/5 px-3'
  },
  {
    column: 'credit_at_time_cents',
    essential: true,
    label: 'Credit At Time',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'promo_at_time_cents',
    essential: true,
    label: 'Promo At Time',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'object_id',
    essential: true,
    label: 'Object ID',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'reason',
    essential: true,
    label: 'Reason',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  }
];
